/**
 * TypeScript 类型定义
 */

import { StudentLevel } from '../config';

/** 报名表单数据 */
export interface FormData {
  studentName: string;
  studentSchool: string;
  studentLevel: StudentLevel;
  phone: string;
  parentName: string;
  mentorName: string;
  mentorPhone: string;
  /** 其他团队成员（可选） */
  teamMembers?: string;
}

/** 报名状态枚举 */
export type RegistrationStatus = 'pending' | 'approved' | 'rejected';

/** 报名状态中文映射 */
export const statusTextMap: Record<RegistrationStatus, string> = {
  pending: '审核中',
  approved: '审核通过',
  rejected: '审核未通过',
};

/** 报名记录 */
export interface Registration {
  id: string;
  studentName: string;
  studentSchool: string;
  studentLevel: StudentLevel;
  phone: string;
  parentName: string;
  mentorName: string;
  mentorPhone: string;
  /** 其他团队成员（可选） */
  teamMembers?: string;
  status: RegistrationStatus;
  statusText: string;
  createdAt: string;
  updatedAt: string;
}

/** 用户信息 */
export interface User {
  phone: string;
  studentName: string;
}

/** 登录响应 */
export interface LoginResponse {
  token: string;
  expiresIn: number;
  user: User;
}

/** 提交报名响应 */
export interface SubmitRegistrationResponse {
  id: string;
  status: RegistrationStatus;
  statusText: string;
  createdAt: string;
}

/** 赛事配置 */
export interface CompetitionConfig {
  registrationDeadline: string;
  trainingStartDate: string;
  trainingEndDate: string;
  isRegistrationOpen: boolean;
  announcement: string | null;
  studentLevels: string[];
}

/** 案例数据 */
export interface CaseItem {
  id: number;
  title: string;
  description: string;
  icon: string;
  tag: string;
  color: string;
}

/** API统一响应格式 */
export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T | null;
}
